import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=7a53bd9e&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=7a53bd9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a53bd9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a53bd9e')) {
      api.createRecord('7a53bd9e', component.options)
    } else {
      api.reload('7a53bd9e', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=7a53bd9e&scoped=true&", function () {
      api.rerender('7a53bd9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2t3MNNoTPJ676/JS/comp/GuestBox.vue"
export default component.exports